const { remove } = require("lodash")

module.exports = {
  common: {
    all: "全部",
    searchPlaceholder: "在7-Eleven搜尋",
    recentlySearched: "歷史搜尋",
    hotKeywords: "熱門搜尋",
    clearAll: "移除全部",
    language: "語言",
    register: "註冊",
    login: "登入",
    home: "首頁",
    searchResult: "搜索結果",
    wellcome: "7-Eleven",
    filter: "篩選",
    sortBy: "排序",
    recommended: "推薦",
    topSales: "高銷量",
    price: "價格",
    brand: "品牌",
    showResult: "顯示結果",
    show: "顯示",
    result: "結果",
    results: "結果",
    lowestFirst: "低價優先",
    highestFirst: "高價優先",
    addToCart: "加入購物車",
    previous: "上一頁",
    next: "下一頁",
    goToPage: "前往",
    go: "跳轉",
    soldOut: "缺貨",
    showMore: "展開",
    showLess: "收起",
    allCategories: "所有分類",
    account: "賬戶",
    addresses: "收貨地址",
    myCards: "我的電子銀包",
    myCoupons: "我的優惠券",
    myOrders: "我的訂單",
    accountSetting: "賬戶設定",
    logout: "登出​",
    point: "積分",
    worth: "價值",
    confirm: "確認",
    cancle: "取消",
    logOutTips: "登出提示",
    logOutMsg: "確認需要登出嗎？",
    logoutSuccess: "登出成功",
    freeDeliveryAbove: "買滿 <span class='free'>{amount}</span> 即享免費送貨",
    freeDeliveryMore: "再買多 <span class='free'>{amount}</span> 即享免費送貨",
    freeDeliveryGet: "太好了！你已可享受免費送貨！",
    viewAll: "查看全部",
    findSimilar: "相似產品",
    similarProducts: "类似商品",
    loginAndregister: "註冊 | 登入",
    signUpSuccess: "註冊成功",
    loginInSuccess: "登入成功",
    selectDeliveryAddress: "選擇收貨地址",
    myAddresses: "收貨地址",
    orderList: "我的訂單",
    collectOrderNotice: "加更多指定產品入購物車以享用優惠",
    orderDetails: "訂單詳情",
    searchResults: "{searchResult}個結果",
    multipleOffers: "多重優惠",
    loginExpired: "登入狀態已經過期，如需繼續操作請重新登入",
    checkYourAddress: "購物之前，請核對你的收貨地址",
    checkYourAddressTips:
      "你的送貨地址將影響商品是否可以購買，爲了確保順利結賬，請確認這是你購物要送往的收貨地址。如需更改請點擊上面的地址進行變更。",
    ok: "ok",
    deliverTo: "送到",
    noAdress: "未檢索到有效的收貨地址",
    addAddress: "添加地址",
    addDeliveryAddress: "添加收貨地址",
    default: "預設",
    similarLikeTitle: "同類商品推薦:",
    categories: "分類",
    noAddressPopTitle: "送貨到什麼地方?",
    noAddressPopContent: "填寫送貨地址後，我們能為你提供更優質的購物體驗",
    backToBrowse: "返回",
    addNewAdd: "新增地址",
    unavaliableDeliveryAddressTips: "很抱歉，我們暫時未能向你的地址提供服務，",
    changeDeliveryAddressTips: "請嘗試更改收貨地址或留意我們進一步的通知，",
    thankYouTips: "謝謝支持。",
    yes: "確認",
    no: "取消",
    logoutfailed: "登出失败",
    customer: "客戶幫助",
    followUs: "關注我們",
    wellCenter: "7-Eleven網購客戶幫助中心",
    storeLocator: "門店位置",
    ourStory: "關於7-Eleven",
    corporateResponsibility: "企業責任",
    corporatePromotions: "推廣優惠",
    contactUs: "聯絡我們",
    careers: "加入我們",
    termsAndConditions: "條款細則",
    restrictedFoodPermits: "受限制食物售賣許可證",
    feedback: "提交意見",
    shareWithCopyText: "成功複製",
    share: "分享",
    bestMatches: "推薦",
    comingSoon: "即將推出",
    notification: "通知",
    linkYuuTips: "綁定yuu賬戶賺取積分，發掘更多yuu 及 7-Eleven 的獨家優惠。",
    myProfile: "個人資訊",
    quickStartGuide: "預購新手攻略​"
  },
  category: {
    result: "结果",
    category: "分类",
    name: "分類",
    noResult: "我們找不到符合你篩選條件的商品，請修改再試試",
    search: "搜尋",
    noResults: "沒有結果",
    all: "所有"
  },
  search: {
    noResultTip: "很抱歉，沒有找到<span class='highlight'>\"{keyword}\"</span> 商品，為您推薦相關的商品：",
    resultTip: "找到 {count} 個與 <span class='highlight'>\"{keyword}\"</span> 相關的商品"
  },
  footer: {
    download: "夠抵夠齊 一APP買到 立即下載",
    faq: "常見問題",
    contact: "聯繫我們",
    email: "電郵",
    payment: "付款方式",
    terms: "電子商務服務條款及細則",
    privacy: "隱私政策",
    dfi: "DFI零售集團",
    storeLocator: "門店位置",
    ourStory: "關於7-Eleven",
    corporateResponsibility: "企業責任",
    corporatePromotions: "推廣優惠",
    careers: "加入我們",
    restrictedFoodPermits: "受限制食物售賣許可證",
    officeHours: "辦公時間",
    followUs: "關注我們",
    officeHoursValue: "星期一至五: 09:00-17:00(公眾假期除外)",
    wellcomeWhatsAppTermsAndConditions: "7-Eleven WhatsApp 條款及細則"
  },
  cms: {
    addToCart: "加入購物車",
    findSimilar: "相似產品",
    soldOut: "缺貨",
    viewAll: "查看全部"
  },
  productDetails: {
    productDetails: "產品詳情",
    youMightAlsoLike: "同類商品推薦",
    freshnessTitle: "Freshness Information",
    freshnessInfo: "7-Eleven致力確保此保鮮產品保質期至少為{num}日，包括送貨當日。",
    size: "規格",
    storage: "儲存方式",
    freshness: "品質",
    country: "產地",
    offers: "推廣優惠",
    description: "產品詳情",
    ProductDetail: "產品詳情",
    redemption: "换購",
    gift: "贈品",
    origin: "產地",
    preOrderPeriod: "預購日期",
    pickupPeriod: "預計取貨日期",
    DeliveryPeriod: "送貨日期",
    Pickup: "自取",
    itemCode: "商品代碼:",
    sameBrand: "相同品牌",
    notAvailable: "不適用",
    notAvailableTips: "該產品無法在所選取的分店取貨，請選擇其他分店。",
    addCartSuccessful: "成功加入購物車",
    limitPurchased: "抱歉，該商品限購{purchaseLimit}件",
    offlinePaymentTips: "此商品僅支持到門店線下支付。請在下單成功後的24小時內到任意一家門店完成付款。"
  },
  paymentSuccessful: {
    tips: "由於銀行處理流程，付款狀態更新可能會延遲約3-5分鐘。謝謝",
    paymentSuccessful: "支付成功！",
    expectedDeliveryDateAndTime: "預計送貨日期及時間:",
    expectedPickupDateAndTime: "預計取貨日期及時間:",
    continueShopping: "繼續選購",
    viewOrder: "查看訂單",
    pickUpDate: "約{date}天後可取貨"
  },
  pendingPayment: {
    pendingPayment: "等待支付",
    tips: "此網上商戶在香港特別行政區運作並且將以港幣(HK$)進行支付",
    with: "",
    saved: "信用卡優惠",
    payFail: "支付出現異常"
  },
  order: {
    all: "全部",
    hideDetails: "隱藏",
    showDetails: "顯示",
    lastThreeMonths: "近3個月的訂單",
    threeMonthsAgo: "3個月以前的訂單",
    ordersFromWebsite: "來自網站的訂單",
    pleaseSelect: "請选择",
    goToAppTips: "請前往7-Eleven應用程式查看更多明細",
    total: "一共",
    pieces: "件",
    orderPlaced: "落單時間:",
    delivery: "配送",
    pickup: "自提",
    parentOrderNo: "主訂單號碼:",
    orderNo: "訂單號碼:",
    // You have not placed any order yet
    noAppOrder: "您暫時還沒有訂單記錄",
    noWebOrder: "您暫時還沒有訂單記錄",
    noWebOrderProcess: "您沒有進行中的訂單",
    noWebOrderComplete: "您沒有已完成的訂單",
    startShopping: "前往購物",
    my: "我的",
    order: "訂單",
    banner: "所有訂單都從您的7-Elevenapp同步。有些訂單可能會被拆分，但我們會在每次購買時一併送貨。",
    syncedOrder: "這是7-Eleven app同步過來的訂單。",
    gift: "赠品",
    redeemed: "換購",
    download: "下載",
    processing: "進行中",
    completed: "已完成",
    loadingText: "加载中...",
    finishedText: "没有更多了",
    pickUpAt: "提貨點:",
    pickUpPeriod: "預計取貨日期:",
    deliveryPeriod: "預計送貨日期:",
    deliveryTime: "送貨日期:",
    qrCode: "二維碼",
    offlineOrderNumber: "訂單編號:",
    offlinePaymentQrCode: "付款二維碼",
    offlinePaymentQrTips: "請到分店完成付款。",
    offlinePaymentTime: "剩餘付款時間",
    orderCancelled: "訂單已取消",
    orderCancelledTips: "付款逾時，訂單已自動取消。",
    orderBtnTxt: "確定",
    copy: "複製",
    feedbackText: "Have a minute? Tell us how we can improve",
    submitFeedBack: "Submit FeedBack",
    showQRtoCashier: "請向收銀員出示二維碼",
    orderNumber: "訂單號碼"
  },
  orderDetails: {
    orderNo: "訂單號碼:",
    checkSignature: "查看簽名",
    eReceipt: "查看收據",
    deleteOrder: "刪除訂單",
    deleteOrderTips: "確定要刪除訂單嗎？",
    cancel: "取消",
    buyAgain: "再次購買",
    stayHere: "留在此頁",
    goToCart: "前往購物車",
    copySuccess: "複製成功",
    deleteOrderSuccess: "訂單已刪除",
    cancelOrderSuccess: "訂單已取消",
    reason: "請選擇一個原因",
    totalItems: "共計{totalCount}件商品",
    freeGifts: "贈品清單",
    free: "免費",
    orderInfo: "訂單信息",
    orderSummary: "訂單概覽",
    saved: "已慳",
    total: "合計",
    relatedOrderNo: "关联訂單號碼:",
    cancelReason: "取消原因",
    reasonPlaceholder: "請選擇一個原因",
    confirm: "确认",
    cancelOrder: "取消訂單",
    cancelAll: "取消全部",
    quantity: "數量",
    productdisabledTitle: "請在7-Eleven app查看商品詳情",
    outOfStock: "缺貨",
    ordersFromDifferentStores: "此訂單包含來自不同商店的多個訂單，請按下一步繼續進行取消。",
    confirmO: "下一步",
    pendingPaymentTips: "此訂單包含來自不同商店的多個訂單，請按下一步繼續進行結帳。",
    confirmP: "下一步",
    contactOurDeliveryMan: "聯絡我們的送貨員",
    orderTracking: "訂單跟蹤",
    deliveryAddress: "送貨詳情:",
    deliveryTime: "預計送貨日期:",
    saverStamps: "已賺取的電子印花",
    funStamps: "已賺取的電子印花",
    stampView: "点击“查看”获取详情",
    view: "查看",
    stampPopupDesc: "所獲得的印花數量係根據以下相關生鮮訂單的總金額計算得出。",
    vendorInfoTitle: "Vendor Information"
  },
  dshop: {
    activityNotStarted: "推廣活動尚未開始，請稍後重試({code})",
    activityOver: "推廣活動已經結束，多謝支持({code})",
    activityRegionNotMatch: "遺憾的是，此活動不適用於您選擇的商店。 請選擇其他商店。",
    activitySorryWrong: "不好意思，發現數據異常，請重試({code})",
    retry: "重試",
    goToHomepage: "返回首頁",
    allCategories: "全部 {num} 個分類",
    storeIsNotAvailable: "此商店暫時不可用"
  },
  cart: {
    my: "我的",
    myCart: "我的購物車",
    selectAll: "選擇全部",
    remove: "移除",
    addMore: "選購更多",
    deliverTo: "送到",
    change: "更改",
    edit: "編輯",
    coupons: "優惠券",
    applied: "張已使用",
    available: "可用",
    total: "合計",
    totleSaved: "優惠",
    saved: "已慳",
    checkout: "結帳（{count}）",
    removeTitle: "從購物車移除商品",
    removeMessage: "是否需要移除你選擇的商品？",
    cancel: "取消",
    addressChangedTips: "已將可以配送的商品更新至你的購物車",
    stockTips: "只剩{stock}件",
    maximumStockTips: "商品數量已達庫存上限",
    rangeNotNearestTitle: "以下商品已添加到不同的送貨地區或送貨方式購物車中。請更改您的地址或送貨方式來恢復它們",
    rangeStandardDeliveryTitle: "以下商品無法送達，請前往7-Eleven應用程式享受完整體驗",
    unRangeStoreGroupTitle: "以下商品無法使用“極速送貨”或“精選預訂”，請前往7-Eleven應用程式享受完整體驗",
    deliveryAndPackagingFee: "含送貨費 ${deliveryFee} + 包裝處理費 ${packagingFee}",
    onlyDeliveryFee: "含送貨費 ${deliveryFee}",
    onlyPackagingFee: "含包裝處理費 ${packagingFee}",
    handlingAndPackagingFee: "含自提處理費 ${handlingFee} + 包裝處理費 ${packagingFee}",
    onlyHandlingFee: "含自提處理費 ${handlingFee}",
    saveMoreOffersTitle: "更多著數優惠，幫你慳到盡",
    viewMore: "展開",
    viewLess: "收起",
    emptyText: "您的購物車是空的",
    continueShopping: "繼續選購",
    freeGifts: "贈品清單",
    soldout: "缺貨",
    free: "免費",
    unavailableWaresTitle: "由於送貨區域或送貨方式的變更，您的購物車可能已經變更。在下方查看已移除的商品",
    findSimilar: "相似產品",
    editRecipient: "編輯收件人信息",
    mandatoryFields: "* 必填項",
    recipientName: "收件人姓名*",
    recipientMobileNumber: "聯絡電話*",
    email: "電郵*",
    emailMessae: "請確認電郵地址是否正確",
    emailShow: "請輸入收件人資料",
    emailEnter: "請輸入電郵地址",
    emailDescription: "此電郵地址只用於接收訂單更新通知.",
    recipientWarningTextWith11Digits: "請輸入你的11位數手機號碼",
    recipientWarningTextWith8Digits: "請輸入你的8位數字的手機號碼",
    save: "確認",
    myAddresses: "我的收貨地址",
    select: "揀選",
    giftSelectMsg: "揀選{maxGiftQty}件贈品",
    changedGiftOrTradeMsg: "您的贈品/換購品優惠已經更新",
    changedGiftOrTradeMinorMsg: "由於購買數量的更改，您的贈品/換購品已經更新",
    redeemFreeMsg: "免費換購指定商品",
    redeemVerticalReductionMsg: "換購指定商品即慳${value}",
    redeemDiscountMsg: "換購指定商品即享{value}折優惠",
    redeemSpecialOfferMsg: "換購指定商品僅需${value}",
    slaveStoreMsg: "您在7-Eleven app其他商店選購的商品已同步，現可於7-Eleven網站一起結帳",
    slaveStoreTip: "請在7-Eleven app查看商品詳情",
    RedeemNow: "換購",
    GoBack: "返回",
    pickUpAt: "於此門市取貨",
    deliveryOnlyDesc: "{count}件商品僅可提供送貨上門服務",
    seeItems: "查看商品",
    deliveryOnlyTitle: "以下商品只限送貨上門",
    reminder: "溫馨提示",
    giftMessage: "你尚未選擇足夠贈品，是否仍需要繼續結賬？",
    no: "否",
    yesContinue: "繼續結賬",
    giftNotEnough: "抱歉，該免費贈品庫存不足",
    allGiftOutOfStock: "所有贈品暫時無法提供",
    pleaseEnterPickupName: "請輸入取貨人的姓名",
    pickAt: "取貨於​",
    separateOrderDesc: "由於取貨時間不一致，訂單有機會被分拆。​",
    shopTips: "件商品無法在所選自取店鋪購買，請選擇其他支持這些商品的店鋪。",
    UnavailableGoods: "不可購商品",
    done: "完成",
    delete: "删除",
    salesAreaHK: "僅限香港",
    salesAreaMacao: "僅限澳門",
    designatedStore: "指定門店",
    salesAreaHKPickUp: "僅限香港取貨",
    salesAreaMacaoPickUp: "僅限澳門取貨",
    salesAreaOnlyHKPickUp: "香港",
    salesAreaOnlyMacaoPickUp: "澳門",
    cart_pick_up: "自提",
    cart_delivery: "配送",
    deliveryMethod: "配送方式",
    pleaseAddAnAddress: "請添加收貨地址",
    addAddress: "添加",
    myAddress: "我的地址",
    selectDeliveryAddress: "选择配送地址",
    SelectableAtCheckout: "(付款時可選擇配送日期)",
    preOrderPickUp: "7仔預購 (自取)",
    preOrderDDelivery: "7仔預購 (送貨)",
    removeAddressTitle: "移除該收貨地址?",
    removeAddressCancel: "取消 ",
    removeAddressConfirm: "確認 "
  },
  coupon: {
    myCoupons: "我的優惠券",
    emptyText: "你現在還沒有優惠券",
    usageRules: "使用規則",
    valid: "有效的",
    invalid: "已使用/已過期",
    reedem: "兌換",
    reedemMessage: "優惠券已成功兌換！",
    daysLeft: "最後{count}日",
    effectivePeriod: "有效期",
    applicableFor: "適用於",
    coupons: "優惠券",
    apply: "使用",
    applySuccessMessage: "優惠券已成功使用！",
    applyInapplicableMessage: "抱歉，此優惠券不適用於當前訂單。詳情請參閱此券使用規則。",
    chosenSavedText: "你已經選中 {length} 張優惠券，並且慳了",
    applicable: "適用",
    inapplicable: "不適用",
    enterPlaceholder: "輸入你的優惠券代碼",
    EGiftVoucher: "網購現金券",
    ECoupon: "電子優惠券",
    combinedText: "可與其他優惠券同時使用"
  },
  checkout: {
    isFull: "Full",
    deliveryTipsTitle: "我們委派的送貨車隊將會於送貨前通知收貨人並確認安排。",
    deliveryTipsContent: "如送貨地點屬於偏遠地區，收貨時或需支付額外付加費，下單前請查閱相關產品頁面之送貨詳情。",
    QTY: "數量",
    paymentTips: "網站暫時只接受信用卡付款",
    and: "以及",
    mark1: "請於送貨前聯絡我",
    mark2: "請將貨品放於門口",
    markAny: "其他指引，請在此填寫",
    save: "確認",
    headerTitle: "安全結賬",
    deliverTo: "送貨到",
    edit: "編輯",
    addDeliveryIns: "添加送貨指引",
    deliveryIns: "送貨指引",
    deliverTime: "送貨時間",
    pleaseSelect: "請選擇",
    noAvailable: "無可選送貨時間段",
    coupons: "優惠券",
    available: "可用",
    applied: "張已使用",
    paymentMethod: "付款方式",
    cardTips: "目前我們網站只接受信用卡（僅Visa和MasterCard）進行付款",
    cardTips2:
      "當你新增信用卡時，發卡機構可能會向你的信用卡暫時收取HK$0.10的費用，確保你輸入的信用卡資料有效，驗證成功後會退回。",
    promotionTips: "今日使用恆生enJoy卡購買7-Eleven以及Market Place商品單一簽賬淨值滿$100或以上，可獲92折",
    addNewCard: "添加信用卡",
    bindNewCardAndPay: "綁定信用卡並支付",
    orderReview: "訂單覆核",
    DSecureAuth: "3DS安全驗證",
    add: "添加",
    change: "更改",
    select: "選擇",
    next: "下一步",
    payNow: "付款並驗證",
    cardVeri: "信用卡驗證",
    mandatoryFileds: "必填項",
    cardNumber: "信用卡號",
    creditCardNumber: "卡片正面顯示的信用卡號碼",
    expiryDate: "到期日 (月/年)",
    mm: "月",
    yy: "年",
    digits: "卡片背面顯示的最後3位數",
    cardholderName: "持卡人姓名",
    nameOnCard: "卡片正面顯示的持卡人姓名",
    saveTips: "保存此卡用於下次付款",
    saveTips2: "我理解我的信用卡資料將儲存於我的帳號中並於將來的交易中使用",
    showDetails: "顯示",
    hideDetails: "隱藏",
    total: "共計",
    total2: "總額",
    item: "件商品",
    orderSummary: "訂單概覽",
    infoTips: "如遇缺貨，其他商品繼續配送（缺貨商品將會自動退款）",
    pay: "結帳",
    saved: "優惠",
    summaryTips1: "點擊「結賬」即表示我同意",
    summaryTips5: "點擊「總額」即表示我同意",
    summaryTips2: "將適用於本交易。",
    summaryTips3: "<span style='font-weight: bold;'>付款確認後無法取消或退款</span>。",
    errorTips: "異常狀態",
    bindCardSuccess: "绑卡成功",
    Including: "含",
    deliveryFee: "送貨費",
    packagingHandlingFee: "包裝處理費",
    week: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
    month: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
    format: "zh",
    freeGifts: "贈品清單",
    free: "免費",
    note: "提示",
    backToCart: "回到購物車",
    pendingPayment: "等待支付",
    notice: "告示",
    text: "當標準產品一經下單，並由我們開始/確認為閣下包裝、揀選或交付產品後，閣下就不能取消或取消該訂單。而任何特定產品一經下單，付款確認後不可取消。",
    tipsCancel: "未滿18歲",
    tipsConfirm: "已滿18歲",
    noCardTips: "請選擇您的付款方式",
    payAnyway: "繼續付款",
    error: {
      cardNumber: "請使用Visa或MasterCard信用卡，並核對卡號是否正確",
      expiryDate: "到期日期不正確或未填寫",
      securityCode: "CVV錯誤或未填寫"
    },
    systemError: "停留在此頁面時間過長，頁面已失效，請退出後重新進入",
    homeDelivery: "送貨上門",
    clickCollect: "網購自取",
    pickAt: "於此門市取貨",
    noTimeTips: "請選擇配送時間",
    recommended: "推薦",
    continueWithThisSlot: "選擇此時段取貨",
    unableTips: "剔除有關商品或會令促銷和贈品選項有所調整。同時可能需支付運費。",
    viewCart: "查看購物車",
    processCheckout: "前往付款",
    unavailableItems: "暫時缺貨的商品",
    unavailableItemsWarn: "若選擇此時段，以下商品將不會與本訂單一同結算，但會保留在購物車中。",
    unavailableItemsText: "如選擇此時段，有關優惠，推廣，贈品和獎賞或有所調整",
    redeemed: "換購",
    gift: "贈品",
    full: "已滿",
    deliveryFee2: "運費：",
    deliveryDateTitle: "更改送貨日期",
    deliveryDateContent: "選擇適合的送貨日期",
    gotIt: "了解",
    offlinePayment: "到店付款",
    placeOrder: "總額：",
    placeOrderSuccess: "訂單已提交 (待到店付款)",
    offlinePaymentStoreTips: "請於 24 小時內到任何分店付款以完成訂單",
    qrCodeCashier: "付款二維碼",
    offlineViewOrder: "查看訂單詳情",
    chooseDeliveryDate: "選擇送貨日期 ",
    deliveryDescribe: "我們將會於送貨前與您聯繫。",
    deliveryTime: "送貨時間",
    pleaseselect: "請選擇",
    selectDeliveryTime: "選擇送貨日期",
    beforeDelivery: "我們將會於送貨前與您聯繫。",
    paymentReminder: "請選擇支付方式及時間以繼續訂單",
    selectPayMethod: "選擇支付方式",
    titleTips: "網站暫時只接受信用卡付款",
    plsSelectTips: "選擇支付方式",
    addCardTipsTitle: "新增信用卡",
    addCardTipsContent: "將於下一頁填寫卡資料"
  },
  card: {
    myCards: "我的電子銀包",
    add: "添加新卡",
    deleteCard: "解除綁定",
    confirmText: "解除綁定後，將不可使用此卡進行支付",
    cancel: "取消",
    confirm: "確定解除",
    message: "解绑成功",
    expiredTips: "你的信用卡已過期"
  },
  pageTitle: {
    cart: "購物車",
    checkout: "安全結賬",
    cards: "電子銀包",
    coupons: "優惠券",
    order_list: "我的訂單",
    order_details: "訂單詳情",
    cashier: "收銀台",
    payment: "支付成功",
    categoryName: "{name}",
    storeLocator: "門店位置",
    notification: "通知",
    loginOrRegister: "登入 / 註冊"
  },
  getTheApp: {
    title: "7-Elevenapp讓7-Eleven手機網購更簡單、輕鬆、快捷！ ",
    description: "立即打開7-Eleven網購，挑選心儀的商品吧！",
    goTo: "打開7-Eleven",
    notNow: "下次再說"
  },
  page: {
    title: "7-Eleven官方網店",
    description:
      "全新「７仔預購網店」正式上線！新網店為大家提供更全面、更方便的一站式預購體驗、讓你一Click預購心頭好！同場加映限定即時扣減優惠，快啲入嚟「預」快購入心水產品啦"
  },
  error: {
    pageNotFound: "頁面未找到",
    serverError: "服務器錯誤",
    backHome: "返回首頁",
    notFound: "404 - 頁面未找到",
    notFoundTips: "很抱歉，我們找不到你要的頁面。",
    internalServerError: "500 - 服務器錯誤",
    internalServerErrorTips: "很抱歉，服務器出現錯誤。"
  },
  collect: {
    bestOfferTitle: "智慳智抵價",
    bestOfferText1: "與產品相關的優惠",
    bestOfferText2: "揀選更多推廣產品以享用優惠",
    selectNum: "揀選{num}件",
    completed: "已完成",
    showMore: "更多",
    collapse: "收起",
    unavailable: "不可使用"
  },
  auth: {
    phoneNumber: "手機號碼",
    login: "登入",
    signUp: "註冊",
    changePwd: "修改密碼",
    forgotPwd: "忘記密碼？",
    smsCode: "短信驗證碼",
    enterPhoneNumber: "請輸入手機號碼",
    enterYourPwd: "請輸入密碼",
    password: "密碼",
    setNewPassword: "設置新密碼",
    submit: "提交",
    or: "或",
    loginWithSMS: "使用短信登入",
    loginWithPwd: "使用密碼登入",
    connectWith: "使用以下方式登入",
    register: "註冊",
    noAccount: "沒有賬戶？",
    SMSVerification: "短信驗證",
    enterSMSCode: "請輸入驗證碼",
    sendSMS: "發送驗證碼",
    alreadyHaveAccount: "已有賬戶？",
    protocal1: "(i) 您已閱讀並同意本",
    termsAndConditions: "條款及細則",
    PICS: "收集個人資料聲明",
    and: "及",
    privacyPolicy: "私隱政策",
    protocal2: " DFI(擁有及營運本程式)將會按上述提及的",
    directMarketingPurposes: "直銷用途",
    protocal3: " 使用您的個人資料以作",
    checkTip: "，如不希望 DFI 作此舉，請在此方框内打勾。​",
    comma: "、",
    period: "。",
    createANewAccount: "建立新賬戶？",
    createAccount: "建立賬戶",
    createAccountContent: "你的手機號碼尚未註冊 7-Eleven 賬戶，請建立賬戶或輸入其他登入信息",
    enterYourPassword: "請輸入密碼",
    enterYourNewPassword: "請輸入新密碼",
    invalidPhoneNumber: "請輸入有效的手機號碼",
    termsAndConditionsRequired: "請閱讀並同意條款細則",
    // sign up modal
    loginWithYourAccount: "使用你的賬戶登入",
    registeredAccount: "你的手機號碼已經註冊 7-Eleven 賬戶，請返回登陸頁面使用你的賬戶登入",
    // create password modal
    skip: "跳過",
    createPassword: "為你的賬戶設置密碼",
    reconfirmPassword: "確認密碼",
    repeatYourPassword: "重複輸入密碼",
    resetPasswordSuccess: "修改密碼成功",
    passwordRule: "請輸入6-16位字母數字組合的密碼",
    signUpTips: "對於新登記的用戶，在核實身份後將自動建立7-Eleven的賬戶。",
    loginOrRegister: "登入 / 註冊",
    loginOrRegisterTips: "登入或註冊成為 yuu 會員，即可賺取 yuu 積分",
    loginNextTips: "請點擊「下一步」按鈕，即表示您確認：​",
    protocalNewRegistration: "(ii) 如您已使用同一電話號碼註冊成為yuu 會員，則同意註冊7-Eleven賬戶並自動進入登入頁面。​",
    verificationPageTips: "輸入發送到 {phone} 的驗證碼以繼續",
    EnterVerificationCode: "輸入驗證碼",
    continueWithAsYuuMember: "綁定 yuu 帳戶",
    yuuTips1: "賺取yuu積分，發掘更多yuu 及 7-Eleven 的獨家禮遇。",
    earnYuuPoints: "賺取 yuu 積分",
    cantEarnYuuPoints: "賺取 yuu 積分",
    collect7EleventAndYuuStamp: "賺取 7-Eleven 和 yuu 印花",
    cannotCollect7EleventAndYuuStamp: "儲 7-Eleven 及 yuu",
    continueAsYuuMember: "以 yuu 賬戶繼續",
    continueWithYuu: "以 yuu 賬戶繼續",
    yuuTips2: "點擊“綁定 yuu 帳戶”後，您的個人信息將傳遞給 7-Eleven 。",
    yuuTips3: "（*包括電話號碼、電子郵件地址、姓名、出生日期和 yuu ID）",
    limitedFunctions: "你可以跳過綁定yuu 賬戶，但以下功能將不能享用: ",
    next: "下一步",
    selectARegion: "選擇地區",
    hongKong: "+852 中國香港",
    macau: "+853 中國澳門",
    china: "+86  中國",
    notContinueYuu: "你確定不用yuu賬戶繼續？",
    notContinueYuuContent: "你將不能賺取yuu積分或儲 7-Eleven 及 yuu 印花",
    letMeThink: "再考慮",
    skipYuu: "確定",
    resend: "重新發送",
    phoneNumberMismatch: "請確保注冊電話號碼與 yuu 的電話號碼保持一致",
    yuuIdBoundToAnotherPhoneNumber: "yuu 账号已被綁定，請聯絡客服。",
    phoneNumberLocked: "yuu 账号已被锁定，請聯絡客服。",
    failedRegistration: "註冊失敗",
    failedToLinkYuuId: "綁定失败",
    linkYuuID: "綁定 yuu",
    gotIt: "知道了"
  },
  address: {
    addNewAddress: "添加新地址",
    confirm: "確定",
    pleaseNoteQuantityAndPromotions: "請留意商品數量和推廣活動可能會根據你選擇的送貨方式而有所不同。",
    edit: "編輯",
    cancel: "取消",
    yes: "確認",
    remove: "移除",
    default: "預設地址",
    defaultAddressTips: "這將自動成為你的預設地址",
    mandatoryFields: "必須填寫",
    address: "地址",
    floorAndUnit: "樓 & 室",
    buildingAndEstate: "大廈 & 屋苑",
    addressLabel: "地址標籤",
    selectDeliveryAddress: "選擇送貨地址",
    addAddress: "添加地址",
    pleaseFillYourAddressHere: "輸入你的地址",
    EgUnit606: "6樓601室",
    pleaseFill: "選填",
    enterAddressLabel: "輸入地址標籤",
    editAddress: "編輯地址",
    removeThisAddress: "刪除此地址？",
    actionCannotUndone: "刪除後無法還原",
    keepAddress: "保留地址",
    addressRemoved: "地址己刪除",
    home: "住宅地址",
    work: "工作地址",
    other: "其他",
    office: "辦公地址",
    makeThisMyDefaultAddress: "設定為我的預設地址",
    noData: "无数据",
    leavePageTipsTile: "確定要取消離開這頁面嗎？",
    leavePageTips: "如果你離開此頁面，你所做的任何更改都將遺失。",
    returnToSite: "返回網站",
    continueEdit: "繼續編輯",
    freeAndFastDelivery: "免費、快捷送貨！",
    addressAdded: "保存成功",
    addressUpdated: "已更新地址",
    loadingText: "加載中",
    userName: "收貨人",
    phone: "手機號碼",
    pleaseEnterName: "請填寫收貨人姓名",
    pleaseEnterPhoneNumber: "請填寫手機號碼",
    empty: "你沒有收貨地址",
    save: "保存",
    placeholderAddress: "請選擇收貨地址",
    searchAddress: "搜索地址",
    unitDetails: "樓層及單位號碼",
    addLabel: "添加標籤",
    unitDetailsPlaceholder: "6號樓301室",
    outsideOfDeliveryArea: "這個地址不在送貨區。",
    searchAddressPlaceholder: "輸入地址/大廈",
    removeTips: "移除該收貨地址？",
    removeError: "當前使用地址不可移除",
    editTips: "放棄編輯地址？",
    notarize: "確認"
  },
  deliveryMethod: {
    title: "送貨方式",
    homeDelivery: "送貨",
    delivery: "送貨",
    Pickup: "自取",
    clickCollect: "網購自取",
    clickCollectTip: "節省更多運費！",
    deliveryOnly: "送貨",
    lowerDeliveryFee: "滿足最低消費金額即享免費門市自取服務",
    nonDeliveryDesc: "訂單滿${amount}元港幣",
    selectPickupStore: "選擇取貨門市",
    provincial: "城市",
    district: "區域",
    area: "地區",
    selectRegion: "請選擇城市",
    selectMunicipal: "請選擇區域",
    // region: "地域",
    // district: "地區",
    storeDisabledDesc: "門市存放空間已滿，請稍後再嘗試。",
    clickCollectNotice: "請留意商品數量和推廣活動可能會根據你選擇的送貨方式而有所不同。",
    confirm: "確認",
    pleaseSelect: "請選擇",
    emptyText: "無數據",
    stayTunedDesc: "更多門市即將推出自取服務，敬請留意！",
    selectAstore: "選擇門店",
    reset: "重設​",
    searchResult: "搜索結果",
    noResultFor: "「{keyword}」沒有結果",
    enterKeywords: "請輸入其他關鍵字",
    noStorePopTitle: "選擇您的取貨門店",
    noStorePopContent: "請選擇您的取貨門店，以便我們為您提供最好的購物體驗"
  },
  storeLocator: {
    fullMapView: "全地圖",
    showListVew: "列表",
    title: "店舖地址",
    region: "區域",
    district: "地區",
    service: "服務",
    listView: "列表",
    mapView: "地圖",
    getDirections: "導航至此分店",
    enterAddressOrBuilding: "搜尋地址",
    openingHours: "營業時間",
    nearestStore: "最近",
    locationError: "Google Maps 無法確定你的精確位置",
    photo: "照片"
  },
  notification: {
    appPushNotification: "推送通知",
    appTips: "收取最新推廣活動的通知",
    smsNotification: "SMS",
    smsTips: "透過短訊收取最新推廣活動的資訊",
    emailNotification: "電郵通知",
    emailTips: "通過電郵獲取最新推廣通知",
    operationSuccessful: "操作成功",
    operationFailed: "操作失敗",
    title: "通知",
    viewAll: "查看全部",
    emptyText: "目前沒有消息。",
    noMoreText: "僅顯示過去三個月的通知",
    learnMore: "了解更多",
    details: "詳情",
    markAllAsRead: "全部標記爲已讀！"
  },
  profile: {
    personalInformation: "個人資訊",
    name: "名字",
    namePlaceholder: "請輸入你的名字",
    email: "電子郵件",
    emailPlaceholder: "請輸入你的電子郵件",
    DateOfBirth: "出生日期",
    DateOfBirthPlaceholder: "月/日/年",
    birthTips: "一旦確認出生日期後，就無法修改。請謹慎輸入。",
    update: "更新",
    enjoyPersonalisedExperience: "享受個性化體驗",
    letUsKnow: "讓我們更了解您"
  },
  linkYuu: {
    id: "yuu ID:",
    title: "綁定yuu ID",
    enterYourYuuId: "請輸入你的yuu ID",
    linkNotice: "已經有yuu ID？立即綁定你的yuu賬戶賺取積分！",
    unlinkNotice: "確定移除yuu ID？",
    cancel: "取消",
    unlink: "移除",
    textWith11Digits: "請輸入8位數yuu ID",
    desc: "綁定yuu帳戶，賺取yuu積分及體驗更多7-Eleven的獨家yuu優惠及獎賞​"
  },
  productLabel: {
    HK_EXC: "香港",
    MO_EXC: "澳門"
  },
  sku: {
    normal: "正常",
    soldOut: "缺貨",
    takeDown: "缺貨",
    blacklist: "缺貨",
    commingSoon: "即將推出",
    outOfStock: "缺貨",
    findSimilar: "相似產品 ",
    quantity: "數量 ",
    add: "加入購物車",
    update: "更新",
    select: "選擇",
    buyNumLabel: "購買數量",
    customizationTitle: "個性化定制"
  },
  login: {
    title: "本網站不支援於當前地區使用，請下載並使用手機應用程式。",
    downloadApp: "下載 App"
  },
  customContent: {
    title: "Custom content",
    default: "Default",
    placeholder: "Please enter your customized content."
  }
}
